import PropTypes from 'prop-types';

export const TagPropType = PropTypes.shape({
  name: PropTypes.string,
  hexColor: PropTypes.string,
  tagId: PropTypes.string,
});

/**
 * @typedef {object} TagPropType
 * @property {string} name
 * @property {string} hexColor
 * @property {string} tagId
 */
